import React, {useEffect} from 'react';
import Header from '../presentations/Header';
import FullScreenContainer from '../presentations/FullScreenContainer';
import ResetPasswordForm from '../containers/ResetPasswordForm';
import {useTranslation} from 'react-i18next';
import { appEnv } from '../config/env';

const ResetPassword = () => {
  const {t} = useTranslation();

  useEffect(() => {
    document.title = `${appEnv.name} - ${t('Password Reset')}`;
  }, []);

  return (
          <>
            <Header/>

            <FullScreenContainer centering={true}>
              <main>
                <ResetPasswordForm/>
              </main>
            </FullScreenContainer>
          </>
  );
};

export default ResetPassword;
